module.exports = __webpack_public_path__ + "bd84388c4939acac826a7dbdc175f602.svg";